import dayjs from 'dayjs';

// Converts the date to a date object. The source may be a string readable by Date or dayjs or a Date object.
// If it is a Date object, it is returned as is, so it should not be mutated.
export function asDate(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
    if (isNaN(date.getTime())) {
      date = dayjs(date).toDate();
    }
  }
  return date;
}

// Converts a date stored as UTC midnight to a date that more easily represents midnight across time zones,
// otherwise returns the date as is.
export function utcMidnightAsInternationalDate(date) {
  date = asDate(date);
  if (isUTCMidnight(date)) {
    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 10));
  }
  return date;
}

// Returns the current date in a Date object that can be used to represent midnight across time zones.
export function nowAsInternationalDate() {
  const date = new Date();
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 10));
}

export function formatInternationalDate(date) {
  return dayjs(date).format('YYYY-MM-DD[T10:00:00Z]');
}

export function getCurrentInternationalDateString() {
  return formatInternationalDate(new Date());
}

export function isUTCMidnight(date) {
  date = asDate(date);
  return date.getUTCHours() === 0 && date.getUTCMinutes() === 0 && date.getUTCSeconds() === 0 && date.getUTCMilliseconds() === 0;
}
